import React from 'react';
import PropTypes from 'prop-types';

import {
    useBranding,
    useIsExportingPNG,
    useIsExportingPDF
} from '../hooks/useExport.js';

import {
    useGetFocusedInstanceIdValue
} from '../hooks/widgetConfiguration.js';


// This is a port of #dashboardTitlebarTemplate
export function PNGHeader({title, subtitles, timePeriodStr}) {

    const branding = useBranding();

    return (
        <div className='tlw-mb-[30px] tlw-flex tlw-items-center tlw-py-5'>
            <img
                className='tlw-max-h-[72px]'
                src={branding.fullLogo || branding.logo}
                alt='export logo'
            />

            <div className='tlw-ml-7.5 tlw-flex tlw-grow tlw-flex-col'>
                <span className='tlw-text-lg'>
                    {title}
                </span>

                {_.map(subtitles, (subtitle, idx) => (
                    <span
                        key={idx}
                        className='tlw-text-md tlw-text-gray-700'
                    >
                        {subtitle}
                    </span>
                ))}
            </div>

            {timePeriodStr &&
                <span
                    className='tlw-text-md tlw-text-gray-700'
                >
                    {timePeriodStr}
                </span>
            }
        </div>
    );
}

PNGHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitles: PropTypes.arrayOf(PropTypes.string),
    timePeriodStr: PropTypes.string
};

// This is a port of #pdfCoverPageTemplate
export function PDFHeader({title, subtitles, timePeriodStr}) {

    const branding = useBranding();

    return (
        <div
            className='tlw-relative tlw-block tlw-h-[100vh] tlw-break-after-page'
        >
            <div className='tlw-absolute tlw-bottom-0 tlw-right-0 tlw-flex tlw-flex-col tlw-text-right'>
                <span className='tlw-my-10 tlw-h-[55px] tlw-text-[47px]'>
                    {title}
                </span>

                {_.map(subtitles, (subtitle, idx) => (
                    <span
                        key={idx}
                        className='tlw-my-5 tlw-text-[20px] tlw-text-gray-700'
                    >
                        {subtitle}
                    </span>
                ))}

                {timePeriodStr &&
                    <span
                        className='tlw-my-5 tlw-text-[20px] tlw-text-gray-700'
                    >
                        {timePeriodStr}
                    </span>
                }

                <img
                    className='tlw-mt-[64px]'
                    src={branding.logo}
                    alt='export logo'
                />
            </div>
        </div>
    );
}

export function ExportHeaders({title, subtitles, timePeriodStr}) {

    const isExportingPNG = useIsExportingPNG();
    const isExportingPDF = useIsExportingPDF();

    const focusedInstanceId = useGetFocusedInstanceIdValue();

    return (
        <>
            {isExportingPNG && !focusedInstanceId &&
                <PNGHeader
                    title={title}
                    subtitles={subtitles}
                    timePeriodStr={timePeriodStr}
                />}

            {isExportingPDF && !focusedInstanceId &&
                <PDFHeader
                    title={title}
                    subtitles={subtitles}
                    timePeriodStr={timePeriodStr}
                />}
        </>
    );

}
